(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  /* ✅ Expose a reliable "top stack height" variable:
   (top banners above header) + (header height)
   so other fixed/sticky bars can sit below the header correctly. */
(() => {
  const headerEl = document.querySelector('.section-header');
  if (!headerEl) return;

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const ease = (t) => t * t * (3 - 2 * t);

  const getAnnouncementEl = () => document.querySelector('.announcement-bar-section');
  const getAnnouncementHeight = () => {
    const el = getAnnouncementEl();
    if (!el) return 0;
    if (getComputedStyle(el).display === 'none') return 0;
    return el.offsetHeight || 0;
  };

  const getMenuBarHeight = () => {
    const bar = document.querySelector('[class^="ai-menu-bar-"]');
    if (!bar) return 0;
    if (getComputedStyle(bar).display === 'none') return 0;
    return bar.offsetHeight || 0;
  };

  const getDealsCarouselEl = () => document.querySelector('[class^="ai-deals-carousel-"]');

  let ticking = false;

  const update = () => {
    const headerH = headerEl.offsetHeight || 0;
    const menuH = getMenuBarHeight();
    const announceH = getAnnouncementHeight();

    let raw = 0;
    const carousel = getDealsCarouselEl();

    if (carousel && announceH > 0) {
      // HOME: hide only after carousel ends (progress over one announcement height)
      const bottom = carousel.getBoundingClientRect().bottom;
      const startLine = announceH + headerH + menuH;
      raw = clamp((startLine - bottom) / announceH, 0, 1);
    } else if (announceH > 0) {
      // OTHER PAGES: hide after first small scroll (1 announcement height)
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      raw = clamp(y / announceH, 0, 1);
    }

    const progress = ease(raw);

    document.documentElement.style.setProperty('--announcement-hide-progress', `${progress}`);
    document.documentElement.classList.toggle('announcement-fully-hidden', progress >= 0.999);

    const topOffset = announceH * (1 - progress);
    const stackHeight = topOffset + headerH;

    document.documentElement.style.setProperty('--sticky-top-offset', `${topOffset}px`);
    document.documentElement.style.setProperty('--sticky-stack-height', `${stackHeight}px`);
  };

  const onScrollOrResize = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  update();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });
  window.addEventListener('load', update, { once: true });
})();


  } catch(e) { console.error(e); }
})();
})();
